import * as mod from 'react-dom';
if (false) {
  module.exports = mod.default;
} else {
  module.exports = mod;
}